import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { jwtDecode } from 'jwt-decode';
import MemberShipVerification from '../pages/MemberShipVerification';
import { TokenPayload } from '@src/interfaces/costcoDashboard.interface';
import { BASE_URL } from '@src/constants/apiEndpoints';

const MemberVerificationGuard = () => {
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
   const token = urlParams.get('token') || localStorage.getItem('costcoVerificationToken');

    if (!token) {
      redirectToSSO();
      return;
    }

    try {
      const decoded = jwtDecode<TokenPayload>(token);
      if (decoded.exp && decoded.exp * 1000 < Date.now()) {
        console.error('Token expired, redirecting to SSO');
        redirectToSSO();
        return;
      }

      if (decoded.pageType === 'Verification' || decoded.pageType === 'User') {
        setIsAuthorized(true);
      } else {
        navigate('/not-authorized', { replace: true });
      }
    } catch (err) {
      console.error('Invalid token, redirecting to SSO');
      redirectToSSO();
    }
  }, []);

  const redirectToSSO = () => {
    const hostname = window.location.hostname;
    const trimmedHost = hostname.split('.').slice(0, -1).join('.');
    const url = `${BASE_URL}/api/v1/mvt/auth/sso?redirect=${trimmedHost}&page=VERIFICATION`;
    console.log('Redirecting to:', url);
    window.location.href = url;
  };

  if (isAuthorized === null) {
    return (
      <div
        style={{
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return <MemberShipVerification />;
};

export default MemberVerificationGuard;
